import logger from '../logger.util';

const L = logger('toggleBlock');

const toggleBlock = (element) => {
  if (!element) {
    return element;
  }

  const { style } = element;
  if (!style) {
    L.warn('The element:', element, "has no valid style attribute, can't toggle display");
    return element;
  }

  style.display = !style.display || style.display === 'none' ? 'block' : 'none';

  return element;
};

// noinspection JSUnusedGlobalSymbols
export default toggleBlock;
